import { HttpInterceptorFn, HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { AuthService } from '../services/auth.service';
import { from, Observable, throwError } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthService);
  const token = authService.jwtToken();

  if (!token || req.url.includes('api.thegraph.com') || req.url.includes('gateway.thegraph.com') || req.url.includes('/auth/refresh')) {
    return next(req).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 401) authService.logout();
        return throwError(() => error);
      })
    );
  }

  // Parse JWT expiration
  let isExpiringSoon = false;
  try {
    const payloadBase64 = token.split('.')[1];
    // Handle base64url format
    const base64 = payloadBase64.replace(/-/g, '+').replace(/_/g, '/');
    const payloadJson = atob(base64);
    const payload = JSON.parse(payloadJson);
    const expTime = payload.exp * 1000;
    // 5 minutes = 300000 ms
    if (expTime - Date.now() < 300000) {
      isExpiringSoon = true;
    }
  } catch (e) {
    console.error('Error parsing token', e);
  }

  if (isExpiringSoon) {
    return from(authService.refreshTokens()).pipe(
      switchMap((refreshed) => {
        if (!refreshed) {
          authService.logout();
          return throwError(() => new Error('Session expired'));
        }
        const newToken = authService.jwtToken();
        const modifiedReq = req.clone({
          headers: req.headers.set('Authorization', newToken!)
        });
        return next(modifiedReq);
      }),
      catchError((error: HttpErrorResponse) => {
        if (error.status === 401) authService.logout();
        return throwError(() => error);
      })
    );
  }

  const modifiedReq = req.clone({
    headers: req.headers.set('Authorization', token)
  });

  return next(modifiedReq).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.status === 401) {
        authService.logout();
      }
      return throwError(() => error);
    })
  );
};